const DEFAULT_ASSET_BASE_URL = "https://d2b9aopujnjeh6.cloudfront.net";
const DEFAULT_CATALOG_POSTULATIONS_PATH = "/api/catalog-postulations/public";
const DEFAULT_CATALOG_ACTIVE_OCCASION_PATH = "/api/catalog-occasions/active";
const DEFAULT_CATALOG_OCCASIONS_PATH = "/api/catalog-occasions/public";

export const CATALOG_PAGE_PATH = "/catalogo";

const sanitizeBaseUrl = (value) => {
  if (!value) {
    return "";
  }

  const trimmed = value.trim();

  if (!trimmed) {
    return "";
  }

  return trimmed.replace(/\/+$/, "");
};

const sanitizeBaseUrlWithSlash = (value) => {
  const sanitizedValue = sanitizeBaseUrl(value);

  if (!sanitizedValue) {
    return "";
  }

  return `${sanitizedValue}/`;
};

const normalizePath = (value, fallbackValue) => {
  const rawValue = typeof value === "string" ? value.trim() : "";
  const pathValue = rawValue || fallbackValue;

  return pathValue.startsWith("/") ? pathValue : `/${pathValue}`;
};

export const ASSET_BASE_URL = sanitizeBaseUrlWithSlash(
  process.env.VUE_APP_ASSET_BASE_URL || DEFAULT_ASSET_BASE_URL
);

export const API_BASE_URL = sanitizeBaseUrl(process.env.VUE_APP_API_BASE_URL);

export const CATALOG_POSTULATIONS_PATH = normalizePath(
  process.env.VUE_APP_CATALOG_POSTULATIONS_PATH,
  DEFAULT_CATALOG_POSTULATIONS_PATH
);

export const CATALOG_ACTIVE_OCCASION_PATH = normalizePath(
  process.env.VUE_APP_CATALOG_ACTIVE_OCCASION_PATH,
  DEFAULT_CATALOG_ACTIVE_OCCASION_PATH
);

export const CATALOG_OCCASIONS_PATH = normalizePath(
  process.env.VUE_APP_CATALOG_OCCASIONS_PATH,
  DEFAULT_CATALOG_OCCASIONS_PATH
);

export const CATALOG_POSTULATIONS_URL = API_BASE_URL
  ? `${API_BASE_URL}${CATALOG_POSTULATIONS_PATH}`
  : "";

export const CATALOG_ACTIVE_OCCASION_URL = API_BASE_URL
  ? `${API_BASE_URL}${CATALOG_ACTIVE_OCCASION_PATH}`
  : "";

export const CATALOG_OCCASIONS_URL = API_BASE_URL
  ? `${API_BASE_URL}${CATALOG_OCCASIONS_PATH}`
  : "";

export const LEGACY_CATALOG_ENDPOINT_URL = `${ASSET_BASE_URL}navidad-2025/entrepreneurs.json`;

export const CATALOG_OCCASIONS = [
  {
    label: "San Valentín",
    value: "san_valentin",
    icon: "❤️",
  },
  {
    label: "Navidad",
    value: "navidad",
    icon: "🎄",
  },
  {
    label: "Día de las Madres",
    value: "dia_de_las_madres",
    icon: "🌷",
  },
  {
    label: "Día del niño",
    value: "dia_del_nino",
    icon: "🧸",
  },
  {
    label: "Día de la secretaria",
    value: "dia_de_la_secretaria",
    icon: "💐",
  },
  {
    label: "Back to school",
    value: "back_to_school",
    icon: "🎒",
  },
  {
    label: "Merchandising",
    value: "merchandising",
    icon: "🛍️",
  },
  {
    label: "Regalos corporativos",
    value: "regalos_corporativos",
    icon: "💼",
  },
];

export const CATALOG_CATEGORY_OPTIONS = [
  "Gastronomía y alimentos",
  "Decoración, Hogar y Jardín",
  "Deportes y actividades al aire libre",
  "Joyas y accesorios",
  "Mascotas",
  "Niñ@s e Infantes",
  "Salud y Belleza",
  "Servicios",
  "Vestuario y Calzado",
  "Otros",
];
